import { Button, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import { errorNotification, successNotification } from '../../../utils/utils';
import { forgotPassword } from '../../actions/figaroApiActions';

type IProps = { history: any; match: any; location: any };

interface IState {
  email: string;
  attempted: boolean;
  successful: boolean;
}

class ForgotPasswordPanel extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    let email = new URLSearchParams(props.location.search).get('email');
    console.log('ForgotPasswordPanel ctor,  props ', props);
    console.log('email: ', email);
    this.state = {
      successful: false,
      email: email,
      attempted: false,
    };
  }

  render() {
    return (
      <div className="login-wrapper">
        <Paper>
          <div className="login-wrapper__header">
            <div className="header-container no-margin text-center w-100">
              <p className="no-margin">Request Figaro Password Reset</p>
            </div>
          </div>
          <form className="login-wrapper__form">{this.renderUserProfile()}</form>
        </Paper>
      </div>
    );
  }

  private renderUserProfile() {
    return (
      <div className="fig-vertical-middle fig-direction-column w-100">
        <TextField
          className="w-100"
          id="email"
          //label="Email"
          type="email"
          value={this.state.email}
          onChange={(e) =>
            this.setState({
              email: e.target.value,
            })
          }
          InputLabelProps={{
            shrink: true,
          }}
          placeholder={'EMAIL'}
          margin="normal"
          variant="outlined"
          required
          error={this.state.attempted && (!this.state.email || this.state.email.length === 0)}
        />

        <Button className="fig-button ghost-to-dark-blue margin-top--30" onClick={this.onForgotPassword}>
          Reset Password
        </Button>
      </div>
    );
  }
  onSuccesfullyForgotten = () => {
    successNotification(
      'Password reset request sent successfuly! To complete the password reset process, please check your e-mail and click the confirmation link.'
    );
    this.setState({
      successful: true,
    });
  };
  onForgotPassword = () => {
    if (this.state.email && this.state.email.length > 0) {
      forgotPassword(this.state.email).then(
        () => this.onSuccesfullyForgotten(),
        (err) => {
          errorNotification('Forget password failed!');
          console.log('forgot password err ', err);
        }
      );
    } else {
      alert('Mandatory field missing');
    }
    this.setState({
      attempted: true,
    });
  };

  onSuccesfullRegister = () => {
    successNotification('Successful e-mail confirmation! ');
    this.setState({
      successful: true,
    });
  };
}

export default ForgotPasswordPanel;
